import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import { Incidents } from "@/shared/interfaces/erp/noc/orden-trabajo-noc.interface";

export const useTableColumnsIncidents = () => {

  const columnsIncidents = useMemo<MRT_ColumnDef<Incidents>[]>(
    () => [
      {
        accessorKey: 'name',
        header: 'NOMBRE DE LA INCIDENCIA',
      },
      {
        accessorKey: 'requireCoordinates',
        header: 'REQUIERE COORDENADAS',
        Cell: ({ row }) => row.original?.requireCoordinates ? "SI" : "NO"
      },
      {
        accessorKey: 'isBoxInstallation',
        header: 'REQUIERE INSTALACIÓN DE CAJAS',
        Cell: ({ row }) => row.original?.isBoxInstallation ? "SI" : "NO"
      },
      {
        accessorKey: 'activityType.nameActivityType',
        header: 'TIPO ACTIVIDAD ASOCIADA',
      },
    ],
    [],
  );

  return {
    columnsIncidents,
  }
}